<script>
export default {
  name: "DidoCatalog404",
};
</script>

<script setup>
import { inject } from "vue";

// inject route and method for updating route from root component
const setCurrentRouteFromUrl = inject("setCurrentRouteFromUrl");

const props = defineProps({
  textMessage: { type: String, required: true, default: "" },
});

const goToHome = () => {
  window.history.pushState(null, "DidoExplore", "?page=explore");
  setCurrentRouteFromUrl();
};
</script>

<template>
  <div class="q-pa-md bg-white text-secondary row-all-center text-center">
    <div>
      <div class="dido-catalogue-404-title">404</div>

      <div class="dido-catalogue-404-subtitle text-h2">
        Oops. Vous ne trouverez rien ici...
      </div>

      <div v-if="props.textMessage" class="q-mt-md text-h6 text-black">
        {{ props.textMessage }}
      </div>

      <QBtn
        class="q-mt-xl"
        color="secondary"
        text-color="white"
        unelevated
        label="Accueil"
        no-caps
        icon="mdi-home"
        @click="goToHome"
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
.dido-catalogue-404-title
  font-size: 30vh
.dido-catalogue-404-subtitle
  opacity:.7
</style>
